import { DisplayTime } from 'common/display-state/display-time.js';

interface IIssuedAt {
  date?: string;
  classes?: string;
}

export const IssuedAt = ({ date, classes }: IIssuedAt) => {
  if (!date) {
    return null;
  }

  return (
    <p className={`fineprint u-textGrey ${classes}`}>
      Issued: <DisplayTime date={date} />
    </p>
  );
};
